var map = {
	"./Assignment.svg": 118,
	"./Calendar_Gray.svg": 86,
	"./Checking.svg": 119,
	"./Columns_Black.svg": 47,
	"./Completed.svg": 42,
	"./CompletedGray.svg": 96,
	"./Customer Indentifier Fixing.svg": 120,
	"./Deleted.svg": 94,
	"./Error.svg": 54,
	"./ErrorGray.svg": 97,
	"./Exporting.svg": 121,
	"./Icons-20x20-Arrow_down_Black.svg": 122,
	"./Icons-20x20-Arrow_down_Light Blue.svg": 123,
	"./Icons-20x20-Arrow_up_Black.svg": 124,
	"./Icons-20x20-Arrow_up_Light Blue.svg": 125,
	"./Icons-20x20-Checking_Black.svg": 126,
	"./Icons-20x20-Checkmark_selected_Light Blue.svg": 127,
	"./Icons-20x20-Checkmark_unselect_Light Blue.svg": 128,
	"./Icons-20x20-Checkmark_unselected_Gray.svg": 129,
	"./Icons-20x20-Checkmark_unselected_Light Blue.svg": 130,
	"./Icons-20x20-Close_Gray.svg": 131,
	"./Icons-20x20-Close_Light Blue.svg": 132,
	"./Icons-20x20-Dropdown-Dropdown 1_down_Black.svg": 133,
	"./Icons-20x20-Dropdown-Dropdown 1_left_Light Blue.svg": 134,
	"./Icons-20x20-Dropdown-Dropdown 1_left_Light Blue_disabled.svg": 135,
	"./Icons-20x20-Dropdown-Dropdown 1_right_Gray.svg": 85,
	"./Icons-20x20-Dropdown-Dropdown 1_right_Light Blue.svg": 136,
	"./Icons-20x20-Dropdown-Dropdown 1_right_Light Blue_disabled.svg": 137,
	"./Icons-20x20-Dropdown-Dropdown 1_up_Black.svg": 138,
	"./Icons-20x20-Dropdown-Dropdown 2_left_Light Blue.svg": 139,
	"./Icons-20x20-Dropdown-Dropdown 2_left_Light Blue_disabled.svg": 140,
	"./Icons-20x20-Dropdown-Dropdown 2_right_Light Blue.svg": 141,
	"./Icons-20x20-Dropdown-Dropdown 2_right_Light Blue_disabled.svg": 142,
	"./Icons-20x20-Execute_Black.svg": 143,
	"./Icons-20x20-Move_Black.svg": 144,
	"./Icons-20x20-Move_Light Gray.svg": 145,
	"./Icons-20x20-Password_mostra_Light Blue.svg": 146,
	"./Icons-20x20-Password_nascondi_Light Blue.svg": 147,
	"./Icons-20x20-Profile_Black.svg": 148,
	"./Icons-20x20-Radiobutton_selected_Light Blue.svg": 149,
	"./Icons-20x20-Radiobutton_unselected_Light Blue.svg": 150,
	"./Icons-20x20-Time_Black.svg": 98,
	"./Icons-20x20-Upload_Black.svg": 151,
	"./Icons-Logo-VMA_Blu.svg": 76,
	"./Icons-Navigation-Logout.svg": 75,
	"./Icons-Toggle_off.svg": 152,
	"./Icons-Toggle_on.svg": 153,
	"./Importing.svg": 154,
	"./Pause_icon.svg": 56,
	"./Pending.svg": 99,
	"./PendingGray.svg": 100,
	"./Pin_Gray.svg": 101,
	"./Reset_Light Blue.svg": 43,
	"./Resume_icon.svg": 93,
	"./Search_Gray.svg": 90,
	"./Target File Finded.svg": 155,
	"./Undo.svg": 55,
	"./Updating.svg": 156,
	"./Uploaded.svg": 157,
	"./Visibility_hide_Light Gray.svg": 79,
	"./Visibility_show_Black.svg": 80,
	"./Warning.svg": 95,
	"./arrow_down_Gray.svg": 91,
	"./arrow_up_Gray.svg": 92,
	"./bg black copy 2.svg": 158,
	"./bg black copy 3.svg": 159,
	"./bg black copy 4.svg": 160,
	"./bg black copy.svg": 161,
	"./bg black.svg": 162,
	"./chevronLeft.svg": 82,
	"./chevronLeftDouble.svg": 81,
	"./chevronRight.svg": 83,
	"./chevronRightDouble.svg": 84,
	"./chevron_down_Gray.svg": 88,
	"./chevron_up_Gray.svg": 89,
	"./close.svg": 34,
	"./delete.svg": 102,
	"./file.svg": 57,
	"./logNav_black.svg": 69,
	"./logNav_blu.svg": 70,
	"./logoLux.svg": 53,
	"./manage_accounts_black.svg": 73,
	"./manage_accounts_blu.svg": 74,
	"./order_down_Gray.svg": 78,
	"./order_up_Gray.svg": 77,
	"./pallaBlu.svg": 58,
	"./settingsNav_black.svg": 71,
	"./settingsNav_blu.svg": 72,
	"./status_Completed_Green.svg": 163,
	"./tableNav_black.svg": 67,
	"./tableNav_blu.svg": 68,
	"./template.svg": 103,
	"./voucher.svg": 104,
	"./voucher_b.svg": 105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46;